import axiosClient from "api/axios_client.js";

const apiApproval = {
  getAll: (payload) => axiosClient.post(`/approvals/approval-notifications/get-all`, payload),
  getStats: () => axiosClient.get(`/approvals/approval-notifications/stats`),
  approve: (id, payload) => axiosClient.put(`/approvals/approval-notifications/approve/${id}`, payload),
  reject: (id, payload) => axiosClient.put(`/approvals/approval-notifications/reject/${id}`, payload),
  bulkApprove: (ids, payload) => axiosClient.put(`/approvals/approval-notifications/bulk-approve`, { ids, ...payload }),
  bulkReject: (ids, payload) => axiosClient.put(`/approvals/approval-notifications/bulk-reject`, { ids, ...payload }),
  delete: (ids) => axiosClient.delete(`/approvals/approval-notifications/delete`, { data: { ids } }),
};

export default apiApproval;
